import React from "react";
import styles from './changePasswordOptions.module.css';
import {AccountSettings, Alert} from "@aws-amplify/ui-react";
import {translatePasswordChangeErrorMessages} from "../utils";

const components = {
  CurrentPasswordField: (props) => (
    <AccountSettings.ChangePassword.CurrentPasswordField
      {...props}
      label="Password corrente"
    />
  ),
  NewPasswordField: (props) => (
    <AccountSettings.ChangePassword.NewPasswordField
      {...props}
      label="Nuova password"
    />
  ),
  ConfirmPasswordField: (props) => (
    <AccountSettings.ChangePassword.ConfirmPasswordField
      {...props}
      label="Conferma password"
    />
  ),
  ErrorMessage: ({children}) => (
    <AccountSettings.ChangePassword.ErrorMessage>
      <Alert
        variation="error"
        heading={translatePasswordChangeErrorMessages(children)}
      />
    </AccountSettings.ChangePassword.ErrorMessage>
  ),
  SubmitButton: (props) => (
    <AccountSettings.ChangePassword.SubmitButton
      className={styles.submitBtn}
      {...props}
    >
      Aggiorna password
    </AccountSettings.ChangePassword.SubmitButton>
  ),

}

export default components;